import React from 'react';
import { Field, FieldProps } from 'formik';
import Checkbox from './Checkbox/Checkbox';

interface FormikCheckboxProps {
    name: string
    label: string | React.ReactNode
    onChange?: (data: {
        value: string
        [key: string]: any
    }, event: React.ChangeEvent<HTMLInputElement>) => void
    required?: boolean
    disabled?: boolean
    className?: string
}

const FormikCheckbox: React.FC<FormikCheckboxProps> = ({ name, label, onChange, required, disabled, ...props }) => {
    return (
        <Field name={name}>
            {({ field, form }: FieldProps) => {
                const isDisabled = disabled || form.isSubmitting;
                return (
                    <Checkbox
                        error={form.touched[name] && form.errors[name] ? String(form.errors[name]) : undefined}
                        {...props}
                        {...field}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            field.onChange(e);
                            onChange && onChange({ value: e.target.value, ...props }, e);
                        }}
                        checked={field.value}
                        label={label}
                        name={name}
                        required={required}
                        disabled={isDisabled}
                    />
                );
            }}
        </Field>
    );
};

export default FormikCheckbox;
